// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.number.max-safe-integer.js
 ** module id = 98
 ** module chunks = 0
 **/